/**
 * Feature visibility flags.
 *
 * Plain constants rather than env vars on purpose: deployments do not set env
 * vars, so these defaults are what ships. Flipping one boolean here is the
 * whole re-enable procedure.
 *
 * These hide the feature in the UI only — routes, API endpoints and database
 * rows are deliberately left intact, so nothing is destroyed and turning a
 * feature back on cannot leave orphaned data behind.
 */
export const FEATURES = {
  /**
   * "Buy a Wedding Book" checklist item and any related merchandising.
   * Backing identifier: ChecklistItemIdentifier.BUY_WEDDING_BOOK.
   */
  weddingBook: false,

  /**
   * Speechwriting: the lander, paywall/merchandising cards and modals, the
   * upsell plan, nav entries and the speechwriting checklist items.
   */
  speechwriting: false,
} as const;

export default FEATURES;
